import { createContext, useContext } from 'react'
import type { Source } from '@/api/types'

export type CitationContextValue = {
  sourcesById: Map<string, Source>
  /** Open the sources panel at this source. */
  onOpen: (sourceId: string) => void
}

export const CitationContext = createContext<CitationContextValue | null>(null)

export function useCitations(): CitationContextValue | null {
  return useContext(CitationContext)
}
